import { ClientChatData } from "components/report/ChatArea/hooks";
import { TextSpeachBalloon } from "components/report/ChatArea/TextSpeechBalloon";
import { ChatDataType } from "types/graphqlapi";
import {
  StyledChatCard,
  StyledChatCardContainer,
  StyledChatCardProps,
  StyledhorizontalArea,
  StyledVerticalArea,
} from "./styled";
import React from "react";
import { FileSpeachBalloon } from "components/report/ChatArea/FileSpeachBalloon";
import { NameIcon } from "components/report/ChatArea/NameIcon";
import { Typography } from "components/common";
import { Icon, IconName } from "components/common/Icon";
import {
  StyledMentionedListContainer,
  StyledMentionedSpan,
  StyledWithMentionContainer,
} from "components/report/Mention/styled";
import { SpeachBalloon } from "components/report/ChatArea/SpeachBalloon";
import { colors } from "constants/colors";

type ChatCardProps = {
  chat: ClientChatData;
  name: string;
  createdAt?: string;
  color?: string;
  isMyChat?: boolean;
} & StyledChatCardProps;

export const ChatCard: React.FC<ChatCardProps> = ({
  chat,
  name,
  createdAt,
  color,
  reverse,
  isMyChat,
}) => {
  const getContent = () => {
    switch (chat.type) {
      case ChatDataType.TEXT: {
        if (!chat.text) return;
        return (
          <TextSpeachBalloon
            text={chat.text}
            mentionedList={chat.mentionedMonitorList}
            isMyChat={isMyChat}
          />
        );
      }
      case ChatDataType.FILE: {
        if (!chat.file_type || !chat.src) return;
        else {
          return <FileSpeachBalloon chat={chat} reverse={isMyChat} />;
        }
      }
      case ChatDataType.ICON: {
        if (!chat.text) return;
        const iconName = chat.text as IconName;
        return (
          <StyledWithMentionContainer isMyChat={isMyChat}>
            {chat.mentionedMonitorList &&
              chat.mentionedMonitorList.length !== 0 && (
                <SpeachBalloon
                  background={
                    chat.monitor_id
                      ? colors.white
                      : colors.moderatorTextBalloonBackGround
                  }
                >
                  <StyledMentionedListContainer>
                    {chat.mentionedMonitorList.map((mentioned) => (
                      <StyledMentionedSpan key={mentioned.id}>
                        @{mentioned.name}
                      </StyledMentionedSpan>
                    ))}
                  </StyledMentionedListContainer>
                </SpeachBalloon>
              )}
            <Icon iconName={iconName} width="4rem" />
          </StyledWithMentionContainer>
        );
      }
      default: {
        return;
      }
    }
  };

  return (
    <StyledChatCardContainer reverse={reverse}>
      <StyledChatCard reverse={reverse}>
        {!isMyChat && <NameIcon name={name.slice(0, 1)} color={color} />}
        <StyledVerticalArea isMyChat={isMyChat}>
          <Typography
            text={!isMyChat ? name : ""}
            fontSize="small"
            textAlign={reverse ? "right" : "left"}
          />
          <StyledhorizontalArea reverse={reverse}>
            {getContent()}
            <Typography
              text={createdAt || "送信中"}
              fontSize="small"
              textAlign="center"
            />
          </StyledhorizontalArea>
        </StyledVerticalArea>
      </StyledChatCard>
    </StyledChatCardContainer>
  );
};
